import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, ClockIcon } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
export const BlogPreview = () => {
  const featuredPost = blogPosts.find(p => p.featured) || blogPosts[0];
  return <section className="bg-[#f2efeb] border-t border-[#d9d3cb]" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12 lg:mb-16" data-id="element-26">
          <div data-id="element-27">
            <p className="text-xs sm:text-sm tracking-widest uppercase text-[#c9a875] font-medium mb-4" data-id="element-28">
              From the Blog
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif-display text-[#2b2826] leading-tight" data-id="element-29">
              Insights for{' '}
              <span className="italic text-[#c9a875]" data-id="element-30">wholesalers</span>
            </h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-[#2b2826] font-medium text-sm hover:text-[#c9a875] transition-colors group whitespace-nowrap" data-id="element-31">
            View all articles
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-32" />
          </Link>
        </div>

        <Link to={`/blog/${featuredPost.id}`} className="group grid md:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-33">
          <div className="md:col-span-7 relative overflow-hidden rounded-2xl aspect-[16/10]" data-id="element-34">
            <img src={featuredPost.imageUrl} alt={featuredPost.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-35" />
            <div className="absolute top-4 left-4" data-id="element-36">
              <span className="bg-[#f2efeb]/95 backdrop-blur-sm text-[#2b2826] text-xs font-medium tracking-wide uppercase px-3 py-1.5 rounded-full" data-id="element-37">
                {featuredPost.category}
              </span>
            </div>
          </div>

          <div className="md:col-span-5" data-id="element-38">
            <div className="flex items-center gap-4 text-xs text-[#2b2826]/60 mb-4" data-id="element-39">
              <span className="flex items-center gap-1.5" data-id="element-40">
                <CalendarIcon className="w-3.5 h-3.5" data-id="element-41" />
                {featuredPost.date}
              </span>
              <span className="w-1 h-1 rounded-full bg-[#2b2826]/30" data-id="element-42" />
              <span className="flex items-center gap-1.5" data-id="element-43">
                <ClockIcon className="w-3.5 h-3.5" data-id="element-44" />
                15 min read
              </span>
            </div>

            <h3 className="font-serif-display text-2xl sm:text-3xl md:text-4xl text-[#2b2826] leading-tight mb-5 group-hover:text-[#c9a875] transition-colors" data-id="element-45">
              {featuredPost.title}
            </h3>

            <p className="text-base sm:text-lg text-[#2b2826]/70 leading-relaxed font-light mb-6" data-id="element-46">
              {featuredPost.excerpt}
            </p>

            <div className="flex items-center justify-between pt-6 border-t border-[#2b2826]/15" data-id="element-47">
              <div className="flex items-center gap-3" data-id="element-48">
                <div className="w-9 h-9 rounded-full bg-[#2b2826] flex items-center justify-center text-[#c9a875] font-serif-display text-base" data-id="element-49">
                  {featuredPost.author.charAt(0)}
                </div>
                <span className="text-sm text-[#2b2826]/80 font-medium" data-id="element-50">
                  {featuredPost.author}
                </span>
              </div>

              <span className="inline-flex items-center gap-2 text-[#c9a875] font-medium text-sm group-hover:gap-3 transition-all" data-id="element-51">
                Read article
                <ArrowRightIcon className="w-4 h-4" data-id="element-52" />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>;
};